import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "pdf-wrapper"
}

import { ref, onMounted, computed, toRefs, watch } from "vue";
import { IonContent, modalController, IonPage } from "@ionic/vue";
import { getIcon } from "@/helpers/api";
import { IFile } from "@/modules/a.worksheets/stores/worksheetDataStore";
import PdfViewer from "@/globals/components/PdfViewer/PdfViewer.vue";
import VideoViewer from "@/modules/a.worksheets/views/components/VideoViewer.vue";
import ImageViewer from "@/modules/a.worksheets/views/components/ImageViewer.vue";
import AudioPlayer from "@/modules/a.worksheets/views/components/AudioPlayer.vue";
import { useDeviceStatus } from "@/stores/deviceStatus";
import { getViewerType } from "@/globals/helpers/media/mimeTypeUtils";
import { useWorksheetHandler } from "@/globals/helpers/worksheetHandler";
import { useIFileResolver } from "@/modules/a.worksheets/helpers/useIFileResolver";


export default /*@__PURE__*/_defineComponent({
  __name: 'WksExtraInfoModal',
  setup(__props) {

const { isWeb, isNetConnected } = toRefs(useDeviceStatus());
const wh = useWorksheetHandler();


const x_icon = ref<string>();
onMounted(async () => {
  x_icon.value = await getIcon("1010", "close");
});
const dismiss = () => modalController.dismiss(null, "close");

const singleExtraArray = computed<IFile[]>(() => {
  const f = wh.wksExtraInfoFile.value; 
  return f ? [f] : [];
});

const { resolve } = useIFileResolver();
const resolvedFiles = resolve(singleExtraArray, { isNetConnected: isNetConnected.value });

const currentPage = ref(1);
function handlePageChanged(page: number) {
  currentPage.value = page;
}

const rotation = ref(0);
function rotate() {
  rotation.value = (rotation.value + 90) % 360;
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), {
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
    class: "modal-primary"
  }, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        src: x_icon.value,
        class: "close-icon",
        onClick: dismiss
      }, null, 8, _hoisted_1),
      _createVNode(_unref(IonContent), {
        "force-overscroll": !_unref(isWeb)
      }, {
        default: _withCtx(() => [
          ( _unref(resolvedFiles))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_unref(resolvedFiles)[0] && _unref(getViewerType)(_unref(resolvedFiles)[0].type) === 'pdf')
                  ? (_openBlock(), _createBlock(PdfViewer, {
                      key: 0,
                      source: _unref(resolvedFiles)[0].source,
                      "full-size": true,
                      page: currentPage.value,
                      onPageChanged: handlePageChanged
                    }, null, 8, ["source", "page"]))
                  : (_unref(resolvedFiles)[0] && _unref(getViewerType)(_unref(resolvedFiles)[0].type) === 'video')
                    ? (_openBlock(), _createBlock(VideoViewer, {
                        key: 1,
                        source: _unref(resolvedFiles)[0].source,
                        zoomable: false
                      }, null, 8, ["source"]))
                    : (_unref(resolvedFiles)[0] && _unref(getViewerType)(_unref(resolvedFiles)[0].type) === 'image')
                      ? (_openBlock(), _createBlock(ImageViewer, {
                          key: 2,
                          source: _unref(resolvedFiles)[0].source,
                          zoomable: true,
                          rotation: rotation.value
                        }, null, 8, ["source", "rotation"]))
                      : (_unref(resolvedFiles)[0] && _unref(getViewerType)(_unref(resolvedFiles)[0].type) === 'audio')
                        ? (_openBlock(), _createBlock(AudioPlayer, {
                            key: 3,
                            source: _unref(resolvedFiles)[0].source,
                            type: _unref(resolvedFiles)[0].type,
                            thumbnail: "/assets/Soundwave.svg",
                            zoomable: false
                          }, null, 8, ["source", "type"]))
                        : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["force-overscroll"])
    ]),
    _: 1
  }))
}
}

})